<template>
  <div class="home_H">
    <el-container>
      <el-header class="head_list_sty">
        <div class="top_index">
          <div class="mainbody">
            <div>
              <div
                class="title"
                @mouseenter="handleMouseEnter(index.name, index.iocn)"
                @click="tosecurity(index.name)"
                v-for="index in toplist"
                :key="index.id"
              >
                {{ index.name }} <i :class="index.iocn"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="showdiv" @mouseleave="showdivs = false" v-if="showdivs">
          <div style="width: 1400px">
            <div class="showdiv_for">
              <div v-for="ins in showdivlist" :key="ins.id">
                <div class="showdivlist_lable">
                  {{ ins.lable }}
                </div>
                <div class="for_div_for">
                  <div
                    class="spans"
                    @click="togetapi(inst.name, ins.lable)"
                    v-for="inst in ins.list"
                    :key="inst.id"
                  >
                    <div class="dis_img_name">
                      <img
                        class="iocns"
                        v-if="inst.iocns"
                        :src="inst.iocns"
                        alt=""
                      />
                      <img
                        class="iocnz"
                        v-if="inst.iocnz"
                        :src="inst.iocnz"
                        alt=""
                      />
                      <img v-if="inst.iocn" :src="inst.iocn" alt="" />
                      <div class="spans_div">
                        <div>{{ inst.name }}</div>
                        <div class="span_text">{{ inst.text }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-header>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "Head",
  props: {
    msg: String,
  },
  data() {
    return {
      ggshow: true,
      showdivs: true,
      toplist: [
        {
          id: 111,
          name: "套餐购买",
          // iocn: "el-icon-arrow-down",
          iocn: "",
        },

        // {
        //   id: 112,
        //   name: "获取代理",
        //   iocn: "el-icon-arrow-down",
        // },
        // {
        //   id: 113,
        //   name: "代理产品",
        //   iocn: "el-icon-arrow-down",
        // },
        // {
        //   id: 114,
        //   name: "帮助中心",
        //   iocn: "el-icon-arrow-down",
        // },
        {
          id: 115,
          name: "安全合规",
          iocn: "",
        },
        {
          id: 116,
          name: "企业服务",
          iocn: "",
        },
        // {
        //   id: 117,
        //   name: "推广计划",
        //   iocn: "",
        // },
      ],
      showdivlist: [],

      showdivlistA: [
        {
          lable: "额度充值",
          list: [
            {
              id: 1,
              name: "动态住宅IP",
              iocn: "http://apiupss.ppfly.top/images/icon_1.svg",
            },
            {
              id: 2,
              name: "动态数据中心IP",
              iocn: "http://apiupss.ppfly.top/images/icon_2.svg",
            },
            {
              id: 3,
              name: "静态住宅IP",
              iocn: "http://apiupss.ppfly.top/images/icon_5.svg",
            },
            {
              id: 4,
              name: "独享数据中心IP",
              iocn: "http://apiupss.ppfly.top/images/icon_6.svg",
            },
            {
              id: 5,
              name: "动态长效ISP",
              iocn: "http://apiupss.ppfly.top/images/icon_7.svg",
            },
          ],
        },
        {
          lable: "产品套餐",
          list: [
            {
              id: 6,
              name: "动态住宅套餐",
              iocn: "http://apiupss.ppfly.top/images/icon_8.svg",
              text: "真实的短效家庭住址IP，包月流量，不限IP数量",
            },
            {
              id: 7,
              name: "静态住宅套餐",
              iocn: "http://apiupss.ppfly.top/images/icon_9.svg",
              text: "真实的短效家庭住址IP，7-90天或更长失时效，不限IP数量",
            },
            {
              id: 8,
              name: "独享数据中心套餐",
              iocn: "http://apiupss.ppfly.top/images/icon_10.svg",
              text: "真实的短效家庭住址IP，包月流量，不限IP数量",
            },
          ],
        },
        {
          lable: "最新活动",
          list: [
            {
              id: 9,
              iocns:
                "http://apiupss.ppfly.top/images/ad_img22.svg",
            },
            {
              id: 10,
              iocns:
                "http://apiupss.ppfly.top/images/ad_img3.svg",
            },
            {
              id: 11,
              name: "更多优惠活动",
            },
          ],
        },
      ],

      showdivlistB: [
        {
          lable: "api提取",
          list: [
            {
              id: 14,
              name: "api提取",
              iocn: "http://apiupss.ppfly.top/images/nav_pack_icon6.svg",
            },
            {
              id: 15,
              name: "API教程demo",
              iocn: "http://apiupss.ppfly.top/images/nav_pack_icon7.svg",
            },
          ],
        },
        {
          lable: "账密认证",
          list: [
            {
              id: 16,
              name: "账密认证获取",
              iocn: "http://apiupss.ppfly.top/images/nav_pack_icon8.svg",
            },
            {
              id: 17,
              name: "账密认证Demo",
              iocn: "http://apiupss.ppfly.top/images/nav_pack_icon9.svg",
            },
          ],
        },
        {
          lable: "代理管理器",
          list: [
            {
              id: 18,
              name: "代理管理器",
              iocn: "http://apiupss.ppfly.top/images/nav_pack_icon10.png",
            },
          ],
        },
        {
          lable: "全球地区",
          list: [
            {
              id: 19,
              name: "美国",
              iocnz:
                "http://apiupss.ppfly.top/images/flag_1.svg",
            },
            {
              id: 20,
              name: "英国",
              iocnz:
                "http://apiupss.ppfly.top/images/flag_2.svg",
            },
            {
              id: 21,
              name: "加拿大",
              iocnz:
                "http://apiupss.ppfly.top/images/flag_3.svg",
            },
            {
              id: 22,
              name: "泰国",
              iocnz:
                "http://apiupss.ppfly.top/images/flag_4.svg",
            },
            {
              id: 23,
              name: "印度",
              iocnz:
                "http://apiupss.ppfly.top/images/flag_6.svg",
            },
            {
              id: 24,
              name: "马来西亚",
              iocnz:
                "http://apiupss.ppfly.top/images/flag_8.svg",
            },
            {
              id: 25,
              name: "印度尼西亚",
              iocnz:
                "http://apiupss.ppfly.top/images/flag_7.svg",
            },
            {
              id: 26,
              name: "更多地区",
              iocnz:
                "http://apiupss.ppfly.top/images/most_area.svg",
            },
          ],
        },
      ],

      showdivlistC: [
        {
          lable: "住宅代理",
          list: [
            {
              id: 27,
              name: "动态住宅代理",
              iocn: "http://apiupss.ppfly.top/images/nav_pack_icon1.svg",
              text: "来自真实家庭住宅设备，支持定义IP时效自动轮换",
            },
            {
              id: 28,
              name: "静态住宅代理",
              iocn: "http://apiupss.ppfly.top/images/nav_pack_icon12.svg",
              text: "强大的真人属性，IP地址固定不变，个人独享使用",
            },
            {
              id: 29,
              name: "动态ISP代理",
              iocn: "http://apiupss.ppfly.top/images/nav_pack_icon13.svg",
              text: "真实的长效ISP代理，单个IP最高6h或定制更长IP时长",
            },
          ],
        },
        {
          lable: "数据中心代理",
          list: [
            {
              id: 30,
              name: "动态数据中心",
              iocn: "http://apiupss.ppfly.top/images/nav_pack_icon5.svg",
              text: "高性能数据中心机房IP，支持定义IP时效自动轮换",
            },
            {
              id: 31,
              name: "独享数据中心",
              iocn: "http://apiupss.ppfly.top/images/nav_pack_icon16.svg",
              text: "供个人独享使用的高性能服务器IP，IP地址固定不变",
            },
          ],
        },
        {
          lable: "应用场景",
          list: [
            {
              id: 32,
              iocn: "http://apiupss.ppfly.top/images/apply_ai.png",
            },
            {
              id: 33,
              name: "网页数据采集",
            },
            {
              id: 34,
              name: "电子商务",
            },
            {
              id: 35,
              name: "市场调查",
            },
            {
              id: 36,
              name: "社交媒体营销",
            },
            {
              id: 37,
              name: "SEO优化",
            },
            {
              id: 38,
              name: "了解更多",
            },
          ],
        },
      ],

      showdivlistD: [
        {
          lable: "使用指南",
          list: [
            {
              id: 39,
              name: "快速入门",
              iocn: "http://apiupss.ppfly.top/images/nav_pack_icon11.svg",
              text: "代理获取及使用文档，简单上手",
            },
            {
              id: 40,
              name: "功能介绍",
              iocn: "http://apiupss.ppfly.top/images/nav_pack_icon12.svg",
              text: "代理管理器等功能使用，便捷使用",
            },
            {
              id: 41,
              name: "代理集成",
              iocn: "http://apiupss.ppfly.top/images/nav_pack_icon13.svg",
              text: "浏览器及指纹浏览器配置代理，快速集成",
            },
          ],
        },
        {
          lable: "开发者文档",
          list: [
            {
              id: 42,
              name: "开发者指南",
              iocn: "http://apiupss.ppfly.top/images/nav_pack_icon15.svg",
              text: "丰富的开发者文档，帮助开发者快速开始",
            },
            {
              id: 43,
              name: "代码Demo",
              iocn: "http://apiupss.ppfly.top/images/nav_pack_icon16.svg",
              text: "各类编程语言代码Demo，开发人员友好",
            },
          ],
        },

        {
          lable: "代理使用",
          list: [
            {
              id: 44,
              name: "动态住宅IP",
              iocn: "http://apiupss.ppfly.top/images/nav_pack_icon1.svg",
            },
            {
              id: 45,
              name: "静态住宅IP",
              iocn: "http://apiupss.ppfly.top/images/nav_pack_icon2.svg",
            },
            {
              id: 46,
              name: "动态长效ISP",
              iocn: "http://apiupss.ppfly.top/images/nav_pack_icon4.svg",
            },
            {
              id: 47,
              name: "动态数据中心IP",
              iocn: "http://apiupss.ppfly.top/images/nav_pack_icon5.svg",
            },
            {
              id: 48,
              name: "独享数据中心IP",
              iocn: "http://apiupss.ppfly.top/images/nav_pack_icon3.svg",
            },
          ],
        },
      ],
    };
  },
  components: {},
  mounted() {},
  methods: {
    handleMouseEnter(name, iocns) {
      let trueshow = iocns;
      if (trueshow) {
        this.showdivname = name;
        this.showdivs = true;
        if (name == "获取代理") {
          this.showdivlist = this.showdivlistB;
        } else if (name == "套餐购买") {
          // this.showdivlist = this.showdivlistA;
        } else if (name == "代理产品") {
          this.showdivlist = this.showdivlistC;
        } else if (name == "帮助中心") {
          this.showdivlist = this.showdivlistD;
        }
      } else {
        this.showdivs = false;
      }
    },
    tohome() {
      this.$router.push({ path: "/" }).catch((err) => {
        if (err.name !== "NavigationDuplicated") {
          // 处理其他错误
          console.error(err);
        }
      });
    },
    togetapi(name, lable) {
      if (lable === "api提取") {
        this.$router
          .push({ path: "/getapi", query: { name: name } })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
        this.$router.go(0);
      } else if (lable == "账密认证") {
        this.$router
          .push({ path: "/getapi", query: { name: name } })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
        this.$router.go(0);
      } else if (lable == "代理管理器") {
        this.$router
          .push({ path: "/getapi", query: { name: name } })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
        this.$router.go(0);
      } else if (lable == "账密认证") {
        this.$router
          .push({ path: "/getapi", query: { name: name } })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
        this.$router.go(0);
      } else if (name == "更多地区") {
        this.$router.push({ path: "/area" }).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            // 处理其他错误
            console.error(err);
          }
        });
        this.$router.go(0);
      } else if (name == "美国") {
        this.$router
          .push({ path: "/area_index", query: { name: "美国" } })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
        this.$router.go(0);
      } else if (name == "英国") {
        this.$router
          .push({ path: "/area_index", query: { name: "英国" } })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
        this.$router.go(0);
      } else if (name == "加拿大") {
        this.$router
          .push({ path: "/area_index", query: { name: "加拿大" } })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
        this.$router.go(0);
      } else if (name == "泰国") {
        this.$router
          .push({ path: "/area_index", query: { name: "泰国" } })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
        this.$router.go(0);
      } else if (name == "印度") {
        this.$router
          .push({ path: "/area_index", query: { name: "印度" } })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
        this.$router.go(0);
      } else if (name == "马来西亚") {
        this.$router
          .push({ path: "/area_index", query: { name: "马来西亚" } })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
        this.$router.go(0);
      } else if (name == "印度尼西亚") {
        this.$router
          .push({ path: "/area_index", query: { name: "印度尼西亚" } })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
        this.$router.go(0);
      } else if (lable == "额度充值") {
        this.$router
          .push({ path: "/pay", query: { name: name, lable: lable } })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
        this.$router.go(0);
      } else if (lable == "产品套餐") {
        this.$router
          .push({ path: "/pay", query: { name: name, lable: lable } })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
        this.$router.go(0);
      } else if (name == "动态住宅代理") {
        this.$router
          .push({ path: "/solution", query: { name: name, lable: lable } })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
        this.$router.go(0);
      } else if (name == "静态住宅代理") {
        this.$router
          .push({ path: "/soluution", query: { name: name, lable: lable } })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
        this.$router.go(0);
      } else if (name == "动态ISP代理") {
        this.$router
          .push({
            path: "/solution_dynamic",
            query: { name: name, lable: lable },
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
        this.$router.go(0);
      } else if (name == "动态数据中心") {
        this.$router
          .push({
            path: "/solution_dynamic_data",
            query: { name: name, lable: lable },
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
        this.$router.go(0);
      } else if (name == "独享数据中心") {
        this.$router
          .push({
            path: "/soluution_static",
            query: { name: name, lable: lable },
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
        this.$router.go(0);
      }
    },
    toucenter() {
      this.$router.push({ path: "ucenter" });
    },
    tologin() {
      this.$router.push({ path: "login" });
    },
    touserlogin() {
      this.$router.push({ path: "userlogin" });
    },
    tosecurity(name) {
      if (name == "安全合规") {
        this.$router.push({ path: "/security" }).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            // 处理其他错误
            console.error(err);
          }
        });
      } else if (name == "企业服务") {
        this.$router.push({ path: "/enterprise_services" }).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            // 处理其他错误
            console.error(err);
          }
        });
      } else if (name == "套餐购买") {
        this.$router
            .push({path: "/pay", query: {name: "静态", lable: "产品套餐"}})
            .catch((err) => {
              if (err.name !== "NavigationDuplicated") {
                // 处理其他错误
                console.error(err);
              }
            });
        this.$router.go(0);
      } else if (name == "推广计划") {
        this.$router.push({ path: "/extension" }).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            // 处理其他错误
            console.error(err);
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.gg_left_img {
  position: fixed;
  bottom: 30px;
  left: 24px;
  z-index: 1999;
  display: block;
}

.gg_ret_div {
  position: fixed;
  bottom: 200px;
  right: 24px;
  z-index: 99;
  display: block;
}

.gg_left_top {
  position: fixed;
  bottom: 120px;
  right: 24px;
  z-index: 99;
  display: block;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #edf3fc;
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.5);
}

.gg_left_top > div {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.gg_left_top_i {
  font-size: 20px;
}

.gg_left_top > div > div {
  color: #a6bad3;
  font-size: 13px;
}

.gg_ret_div_div {
  width: 81px;
  height: auto;
  background: #edf3fc;
  box-shadow: 0 0 29px 0 rgba(210, 228, 251, 0.59);
  border-radius: 77px;
  font-family: SourceHanSansCN-Regular;
  padding: 12px 0 40px;
}

.gg_ret_div_div_butts {
  /* width: 68px; */
  height: 81px;
  /* padding-bottom: 20px; */
  display: flex;
  justify-content: space-around;
  flex-direction: column;
}

.gg_ret_div_div_butts > button {
  font-size: 13px;
  color: #475c77;
  margin-top: 1px;
  text-align: center;
}

.gg_ret_div_div_butts_i {
  width: 28px;
  height: 28px;
}

.el-icon-arrow-down,
.el-icon-user {
  font-weight: 600;
}

.el-header,
.el-footer {
  color: #333;
  text-align: center;
  line-height: 60px;
  padding: 0;
  border-radius: 25px;
}

.head_list_sty {
  position: sticky;
  top: 0;
  background-color: #edf3fc;
  z-index: 5;
}
.top_index {
  display: flex;
  justify-content: space-between;
  /* margin-top: 20px; */
  background-color: #edf3fc;
  border-radius: 25px;
  overflow: hidden;
}
.top_index:hover {
  border-radius: 25px 25px 0 0;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}

.mainbody {
  display: flex;
  justify-content: space-between;
  width: 100%;
  z-index: 1;
  /* background-color: aqua; */
}

.mainbody > div {
  width: 100%;
  display: flex;
  justify-content: space-around;
  font-weight: 600;
  background-color: #edf3fc;
}

.letlogs {
  width: 17%;
  display: flex;
  justify-content: center;
  font-size: 40px;
  font-weight: 700;
}

.log {
  width: 50px;
  height: 50px;
  background-image: url("../../assets/logB.png");
  background-size: cover;
}

.imgstop {
  width: 100%;
  height: 50px;
  background-image: url("../../assets/tops.png");
  background-size: cover;
}

.imgstop > div div {
  color: #f15a24;
}

.imgstop_text {
  display: flex;
  justify-self: center;
  background-color: #edf3fc;
  font-size: 25px;
  font-weight: 550;
}

.footbody {
  width: 20%;
  display: flex;
  justify-content: center;
}

.footbody > div {
  /* font-size: 30px; */
  width: 50%;
  display: flex;
  justify-content: space-around;
}

.showdiv {
  display: flex;
  justify-content: center;
  width: 100%;
  border-radius: 0 0 25px 25px;
  background-color: #edf3fc;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}

.title {
  padding: 0 15px 0 15px;
  display: inline-block;
  position: relative;
  cursor: pointer;
}

.showdiv_for {
  width: 100%;
  display: flex;
  justify-content: space-around;
  font-family: SourceHanSansCN-Regula;
}

.for_div_for {
  width: 300px;
  background-color: #409eff;
}

.showdivlist_lable {
  text-align: left;
  padding-left: 10px;
  font-size: 15px;
}

.spans {
  cursor: pointer;
  display: block;
  float: left;
  padding: 10px;
  font-size: 15px;
  line-height: 20px;
  text-align: left;
  margin-right: 6px;
}

.spans_div {
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: left;
  padding-left: 10px;
}

.span_text {
  font-size: 13px;
  margin-top: 5px;
  white-space: nowrap;
  color: #696969;
}

.title::after {
  content: "";
  position: absolute;
  width: 100%;
  transform: scaleX(0);
  height: 3px;
  bottom: 0;
  left: 0;
  background-color: #409eff;
  transform-origin: bottom right;
  transition: transform 0.25s ease-out;
}

.title:hover {
  color: #409eff;
}

.title:hover::after {
  transform: scaleX(1);
  transform-origin: bottom left;
}

.main_body {
  display: flex;
  justify-content: center;
  flex-direction: column;
  scrollbar-width: none;
  padding: 0;
  margin-top: 100px;
}

.H_div_A {
  font-size: 54px;
  font-family: SourceHanSansCN-Medium;
  text-align: center;
  color: #0e0b3d;
}

.H_div_B {
  font-size: 54px;
  font-family: SourceHanSansCN-Medium;
  text-align: center;
  color: #0e0b3d;
}

.H_div_C {
  display: inline-block;
  font-size: 22px;
  color: #444e72;
  text-align: center;
  width: 100%;
  margin-top: 25px;
}

.H_div_D {
  font-size: 14px;
  display: flex;
  justify-content: center;
  background-color: #edf3fc;
}

.div_li {
  padding: 0;
  display: flex;
  align-items: center;
  width: 190px;
  margin-top: 16px;
  font-size: 16px;
  font-family: SourceHanSansCN-Medium;
  color: #252b42;
  line-height: 16px;
  margin-left: 6px;
}

.butts_main {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 49px;
  color: #edf3fc;
  column-gap: 14px;
}

.zhu_ {
  display: block;
  font-size: 14px;
  color: #988f91;
  text-align: center;
  margin-top: 44px;
}

.butt_A {
  cursor: pointer;
  text-align: center;
  width: 191px;
  height: 54px;
  font-size: 18px;
  color: #edf3fc;
  background: linear-gradient(90deg, #347efc, #6edafe);
  box-shadow: 0 12px 11px 0 rgba(29, 104, 250, 0.13);
  border-radius: 36px;
}

.butt_A:hover {
  background: linear-gradient(90deg, #347efc, #347efc);
}

.butt_B {
  cursor: pointer;
  text-align: center;
  width: 191px;
  height: 54px;
  font-size: 18px;
  color: #000000;
  background-color: aliceblue;
  border: 1px solid #000000;
  box-shadow: 0 12px 11px 0 rgba(29, 104, 250, 0.13);
  border-radius: 36px;
}

.butt_B:hover {
  background: linear-gradient(90deg, #347efc, #347efc);
  border: 0cm;
  color: #edf3fc;
}

.main_B6 {
  width: 1700px;
  margin: 0 auto;
  padding-top: 100px;
  background-color: #edf3fc;
}

.main_B6_div {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.main_B6_div > div {
  /* background-color: #0e0b3d; */
  /* height: 278px; */
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.main_B6_div_A {
  width: 262px;
  height: 165px;
  box-sizing: border-box;
  padding-top: 20px;
  /* margin-top: 33px; */
  background: #edf3fc;
  text-align: left;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 50px;
}

.main_B6_div_A_box {
  padding: 20px 10px 20px 10px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 0px 29px 7px;
}

.main_B6_div_A_box > div {
  margin: 2px;
}

.imgs_text {
  display: flex;
  justify-content: left;
}

.top_text {
  font-size: 15px;
  color: #18181b;
  margin: 0 auto;
}

.img_text {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-family: SourceHanSansCN-Medium;
  color: #18181b;
}

.main_B6_div_B_img {
  width: 276px;
  margin-top: 150px;
}

.textB6 {
  margin-left: 45px;
}

.main_B6_div_B {
  width: 262px;
  height: 165px;
  box-sizing: border-box;
  /* padding-top: 20px; */
  /* margin-top: 33px; */
  background: #edf3fc;
  text-align: left;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.main_B6_div_D_div {
  width: 152px;
  height: 145px;
  background: #8d7bf7;
  margin-top: 52px;
  border-radius: 9px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.main_B6_div_D_div_text1 {
  font-size: 34px;
  font-weight: 700;
  color: #edf3fc;
  box-sizing: border-box;
  padding-left: 22px;
  margin-top: 18px;
  text-align: center;
}

.main_B6_div_D_div_text2 {
  font-size: 17px;
  font-family: SourceHanSansCN-Medium;
  color: #edf3fc;
  width: 70%;
  margin: 30px auto 0;
  text-align: center;
}

.main_B6_div > div:hover {
  transform: scale(1.1);
  transition: all 0.6s;
}

.main_B6_div > div {
  transform: scale(1);
  transition: all 0.6s;
}

.div_8 {
  width: 1400px;
  margin: 0 auto;
}

.div_8_div {
  margin-top: 140px;
}

.div_8_top_text {
  margin-bottom: 30px;
  font-size: 16px;
  font-family: SourceHanSansCN-Regular;
  color: #9198a9;
}

.div_8_bot_div {
  display: flex;
  justify-content: space-between;
}

.div_8_bot_div > div:hover {
  transform: translate(0, -20px);
  transition: all 0.6s;
}

.div_8_bot_div > div {
  /* transform:translate(0,-20px); */
  transition: all 0.6s;
}

.div_9 {
  width: 1400px;
  margin: 0 auto;
}

.div_9_div {
  margin-top: 140px;
}

.div_9_top_text {
  margin-bottom: 100px;
  font-size: 40px;
  color: #1b2336;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
}

.div_9_bot_div {
  display: flex;
  justify-content: space-between;
}

.div_10_div {
  width: 1200px;
  margin: 0 auto;
}

.div_10_top_text {
  margin-top: 100px;
  font-size: 40px;
  color: #1b2336;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
}

.div_10_bot_div {
  width: 1400px;
  display: flex;
  justify-content: center;
}

.div_9_bot_div > div:hover {
  transform: translate(0, -20px);
  transition: all 0.6s;
}

.div_9_bot_div > div {
  /* transform:translate(0,-20px); */
  transition: all 0.6s;
}

.div_9_bot_div_H1 {
  text-align: center;
  font-size: 20px;
  color: #242331;
  margin-top: 25px;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
}

.div_9_bot_div_H2 {
  font-size: 16px;
  color: rgba(20, 23, 24, 0.75);
  margin-top: 20px;
  line-height: 25px;
  width: 236px;
  text-align: left;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #edf3fc;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #edf3fc;
}

.carousel_img {
  display: flex;
  justify-content: space-between;
}

.carousel_img_Htop {
  width: 540px;
  font-size: 20px;
  font-family: SourceHanSansCN-Medium;
  color: #141718;
  line-height: 30px;
  text-align: left;
}

.carousel_img_Htop_lis {
  text-align: left;
  margin-top: 50px;
}

.carousel_img_Htop_li {
  font-size: 16px;
  color: #414344;
  position: relative;
  margin: 10px;
}

.carousel_img_div {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.bust_lo {
  margin-top: 48px;
  width: 170px;
  height: 48px;
  background: #1a73e8;
  border-radius: 25px;
  font-size: 18px;
  color: #edf3fc;
  display: block;
  cursor: pointer;
}

.lp_top_text {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-family: SourceHanSansCN-Medium;
  color: #000;
}

.div_3_overflow_y {
  /* height: 700px; */
  /* overflow-y:scroll; */
}

.div_3_overflow_div {
  height: 600px;
}

.div_3_overflow_div_div {
  margin: 0 auto;
  width: 1400px;
  display: flex;
  justify-content: space-between;
}

.div_3_overflow_div_div_lef {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.div_3_overflow_div_div_lef > div {
  text-align: left;
}

.div_3_overflow_div_div_lef > div:nth-child(1) {
  font-size: 38px;
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  color: #141718;
  margin-top: 26px;
}

.div_3_overflow_div_div_lef > div:nth-child(2) {
  font-size: 18px;
  font-family: SourceHanSansCN-Regular;
  color: #141718;
  width: 86%;
  line-height: 29px;
  margin-top: 26px;
}

.div_3_overflow_div_div_lef > div:nth-child(3) {
  display: flex;
  justify-content: left;
  margin-bottom: 35px;
  margin-top: 60px;
}

.div_3_overflow_div_div_lef > div:nth-child(4) {
  display: flex;
  justify-content: left;
}

.lef_text_top {
  font-size: 18px;
  font-family: SourceHanSansCN-Regular;
  color: #141718;
  line-height: 21px;
}

.lef_text {
  font-size: 14px;
  font-family: SourceHanSansCN-Regular;
  color: #414344;
  line-height: 20px;
  margin-top: 12px;
}

.div_11_bot_div {
  width: 100%;
  max-width: 1400px;
  margin: 60px auto 0;
  display: flex;
  flex-wrap: wrap;
  column-gap: 40px;
  row-gap: 78px;
}

.div_11_bot_div > div:hover {
  transform: translate(0, -20px);
  transition: all 0.6s;
}

.div_11_bot_div > div {
  transition: all 0.6s;
}

.div_12_map {
  width: 964px;
  margin: 0 auto;
  position: relative;
}

.map_li {
  width: 10px;
  height: 10px;
  background-color: #6f4287;
  border-radius: 50%;
  position: absolute;
}

.map_li:nth-child(2) {
  left: 577px;
  top: 130px;
}

.map_li:nth-child(3) {
  left: 483px;
  top: 245px;
}

.map_li:nth-child(4) {
  left: 335px;
  top: 44px;
}

.map_li:nth-child(5) {
  left: 262px;
  top: 318px;
}

.map_li:nth-child(6) {
  left: 148px;
  top: 165px;
}

.map_li:nth-child(7) {
  left: 726px;
  top: 210px;
}

.map_li:nth-child(8) {
  left: 760px;
  top: 92px;
}

.div_12 {
  width: 100%;
  margin: 0 auto;
  background: radial-gradient(closest-side at 50% 50%, #6f4287 0, #34187f 100%)
    0 0 no-repeat padding-box;
}

.div_12_div {
  margin-top: 50px;
}

.div_12_top_text {
  margin-bottom: 100px;
  font-size: 40px;
  color: #edf3fc;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
}

.div_12_bot_div {
  display: flex;
  justify-content: space-between;
}

.mapname {
  text-align: center;
  padding: 10px 20px 10px 20px;
  color: #edf3fc;
  width: 50px;
  height: 10px;
  background-color: #0e0b3d;
  border-radius: 25px;
}

.hyzx_main_body {
  width: 1400px;
  margin: 0 auto;
}

.hyzx_main_body_text {
  margin-bottom: 100px;
  margin-top: 80px;
  font-size: 40px;
  color: #1b2336;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
}

.hyzx_H {
  text-align: left;
  font-size: 15px;
  font-family: SourceHanSansCN-Medium;
  color: #242331;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  width: 88.91%;
  margin: 26px auto 0;
}

.hyzx_text {
  text-align: left;
  font-size: 14px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: rgba(11, 10, 51, 0.57);
  line-height: 22px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  width: 88.91%;
  margin: 21px auto 0;
}

.hyzx_but {
  display: flex;
  justify-content: right;
  padding-right: 32px;
}

.bust_hyzx {
  display: flex;
  font-size: 14px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 500;
  color: #1967d2;
  align-items: center;
  justify-content: flex-end;
}

.text_div {
  width: 420px;
}

.text_div:hover {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px,
    rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
}

.hyzx_main_body_divs {
  display: flex;
  justify-content: space-between;
}

.pphz_main {
}

.pphz_main_div_H {
  font-size: 24px;
  color: #9198a9;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  margin-top: 100px;
  margin-bottom: 100px;
}

.img_pphz {
  width: 208px;
}
.dis_img_name {
  display: flex;
  justify-content: center;
}
.dis_img_name > img:nth-child(2) {
  width: 26px;
  height: 26px;
}
.iocnz {
  width: 26px;
  height: 26px;
}
.iocnz + .spans_div {
  width: 80px;
}
</style>
